const PriceEncodingTypes = Object.freeze({
  HTVA: 'HTVA',
  TVAC: 'TVAC',
})

export default PriceEncodingTypes
